import { QueryParam } from "../../../types/api/generic.type";
import {
  GetPotentialMatrixPerformanceResponse,
  GetPotentialMatrixStatsResponse,
} from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixPerformanceService = {
  async get(
    queryParams: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixPerformanceResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response =
      await httpClient.get<GetPotentialMatrixPerformanceResponse>(
        `v1/potential-matrix-performance${params}`,
        { signal },
      );
    return response;
  },
  async getStats(
    queryParams: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixStatsResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response = await httpClient.get<GetPotentialMatrixStatsResponse>(
      `v1/potential-matrix-performance/stats${params}`,
      { signal },
    );
    return response;
  },
};

export default PotentialMatrixPerformanceService;
